import { useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { FaLock } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa";
import { FaChevronUp } from "react-icons/fa";
import { useState, useEffect, useRef } from "react";
import Header from "../Header.js";
import useUser from "../../hook/useUser"
import api from "../../api/axios";

const PreJobPreparation = () => {
    const navigate = useNavigate();
  const location = useLocation();
    const { user } = useUser();
    const [training, setTraining] = useState(null);
    const [openCards, setOpenCards] = useState({
      uniform: false,
      onboardingProcess: false,
      timeTracking: false,
      educationRequirements: false,
    });
    const [openedCards, setOpenedCards] = useState(new Set());
    const [progress, setProgress] = useState(0);
    const canStartQuiz = progress === 100;
    const initialOpenCard = location.state?.openCard;
    const hasAppliedInitialOpen = useRef(false);

    const toggleCard = async (cardKey) => {
      setOpenCards((prev) => ({
        ...prev,
        [cardKey]: !prev[cardKey],
      }));

      // 初めて開いた場合だけ進捗を更新
      if (!openedCards.has(cardKey) && !openCards[cardKey]) {
        const newOpenedCards = new Set(openedCards);
        newOpenedCards.add(cardKey);
        setOpenedCards(newOpenedCards);
        
        const newProgress = (newOpenedCards.size / 4) * 100; // 25%ずつ
        setProgress(newProgress);

        // データベースに保存
        await updateProgress(cardKey, newProgress);
        console.log("database test")
      }
    };

    const updateProgress = async (cardKey, newProgress) => {
      try {
        await api.patch(`/api/employee/${user.employeeId}/progress`, {
          section: cardKey,
          progress: newProgress,
        });
      } catch(err) {
        console.error('Failed to update progress:', err);
      }
    };

    useEffect(() => {
      if (!user || !user.employeeId) return;
      
      // 既存の進捗を読み込む
      const completed = new Set(
        user.modules?.generalTraining?.preJobPreparation?.completedSections || []
      );
      let newProgress = user.modules?.generalTraining?.preJobPreparation?.progress || 0;

      if (initialOpenCard) {
        setOpenCards((prev) => ({
          ...prev,
          [initialOpenCard]: true,
        }));

        if (!hasAppliedInitialOpen.current && !completed.has(initialOpenCard)) {
          completed.add(initialOpenCard);
          newProgress = (completed.size / 4) * 100;
          hasAppliedInitialOpen.current = true;
          updateProgress(initialOpenCard, newProgress);
        }
      }

      setOpenedCards(completed);
      setProgress(newProgress);
      
      const fetchTraining = async () => {
        try {
          const response = await api.get(`/api/employee/${user.employeeId}/training`);
          setTraining(response.data);
        } catch(err) {
          console.error(err);
        }
      };
      fetchTraining();
    }, [user, initialOpenCard]);


    return (
        <>
        <div className="dashboard-wrapper">
            <Header />
            {/* 1ページ前(General Training)に戻る */}
            <div onClick={() => navigate(-1)} style={{ cursor: "pointer" }} className="nav_title">
                <IoIosArrowBack className="fa-caret-left"/>
                Pre-job preparation
            </div>

            {/* progress bar */}
            <progress id="progress-bar" max="100" value={progress}></progress>


            <div className="pre-job-wrapper">
                <div className="pre-job-card">
                    <div className="card-header" onClick={() => toggleCard("uniform")} style={{ cursor: "pointer" }}>
                            <h3>I. {user ? user.modules.generalTraining.preJobPreparation.uniform?.title : "Loading..."}</h3>
                            {openCards.uniform ? (
                              <FaChevronUp className="fa-chevron-up" />
                            ) : (
                              <FaChevronDown className="fa-chevron-down" />
                            )}
                    </div>
                    {openCards.uniform && (
                        <div className="pre-job-items" id="items">
                            {user ? (
                              Array.isArray(user.modules.generalTraining.preJobPreparation.uniform.contents?.content) ? (
                                <ul className="item" style={{ cursor: "pointer" }}>
                                  {user.modules.generalTraining.preJobPreparation.uniform.contents.content.map((content, index) => (
                                    <li key={index}>{content}</li>
                                  ))}
                                </ul>
                              ) : (
                                <p className="pre-job-item">
                                  {user.modules.generalTraining.preJobPreparation.uniform.contents?.content}
                                </p>
                              )
                            ) : (
                              "Loading..."
                            )}
                        </div>
                    )}
                </div>
                <div className="pre-job-card">
                    <div className="card-header" onClick={() => toggleCard("onboardingProcess")} style={{ cursor: "pointer" }}>
                            <h3>II. {user ? user.modules.generalTraining.preJobPreparation.onboardingProcess?.title : "Loading..."}</h3>
                            {openCards.onboardingProcess ? (
                              <FaChevronUp className="fa-chevron-up" />
                            ) : (
                              <FaChevronDown className="fa-chevron-down" />
                            )}
                        </div>
                    {openCards.onboardingProcess && (
                        <div className="pre-job-items" id="items">
                            <p className="pre-job-item">
                                {user ? user.modules.generalTraining.preJobPreparation.onboardingProcess.contents?.content : "Loading..."}
                            </p>
                        </div>
                        )}
                </div>
                <div className="pre-job-card">
                    <div className="card-header" onClick={() => toggleCard("timeTracking")} style={{ cursor: "pointer" }}>
                            <h3>III. {user ? user.modules.generalTraining.preJobPreparation.timeTracking?.title : "Loading..."}</h3>
                            {openCards.timeTracking ? (
                              <FaChevronUp className="fa-chevron-up" />
                            ) : (
                              <FaChevronDown className="fa-chevron-down" />
                            )}
                        </div>
                    {openCards.timeTracking&& (
                        <div className="pre-job-items" id="items">
                            {user ? (
                              Array.isArray(user.modules.generalTraining.preJobPreparation.timeTracking.contents?.content) ? (
                                <ul className="item" style={{ cursor: "pointer" }}>
                                  {user.modules.generalTraining.preJobPreparation.timeTracking.contents.content.map((content, index) => (
                                    <li key={index}>{content}</li>
                                  ))}
                                </ul>
                              ) : (
                                <p className="pre-job-item">
                                  {user.modules.generalTraining.preJobPreparation.timeTracking.contents?.content}
                                </p>
                              )
                            ) : (
                              "Loading..."
                            )}
                        </div>
                    )}
                </div>
                <div className="pre-job-card">
                    <div className="card-header" onClick={() => toggleCard("educationRequirements")} style={{ cursor: "pointer" }}>
                            <h3>IV. {user ? user.modules.generalTraining.preJobPreparation.educationRequirements?.title : "Loading..."}</h3>
                            {openCards.educationRequirements ? (
                              <FaChevronUp className="fa-chevron-up" />
                            ) : (
                              <FaChevronDown className="fa-chevron-down" />
                            )}
                        </div>
                    {openCards.educationRequirements&& (
                        <div className="pre-job-items" id="items">
                            {user ? (
                              Array.isArray(user.modules.generalTraining.preJobPreparation.educationRequirements.contents?.content) ? (
                                <ul className="item" style={{ cursor: "pointer" }}>
                                  {user.modules.generalTraining.preJobPreparation.educationRequirements.contents.content.map((content, index) => (
                                    <li key={index}>{content}</li>
                                  ))}
                                </ul>
                              ) : (
                                <p className="pre-job-item">
                                  {user.modules.generalTraining.preJobPreparation.educationRequirements.contents?.content}
                                </p>
                              )
                            ) : (
                              "Loading..."
                            )}
                        </div>
                    )}
                </div>
            </div>

            <div className="start-quiz-button">
                <button
                  onClick={() => canStartQuiz && navigate("/quiz/69a4ff0759594a1494897e2c/intro")}
                  disabled={!canStartQuiz}
                >
                  Start Quiz
                </button>
            </div>
        </div>    
        </>
    );

}

export default PreJobPreparation;